import { ContentLoading } from "../components/ContentLoading";
import { Button } from "../components/ui/button";
import { FieldError } from "../components/ui/field";

export function RetrievalPageControls({
  error,
  pending,
  fetching,
  hasMore,
  loadMore,
  label,
}: {
  error: Error | null;
  pending: boolean;
  fetching: boolean;
  hasMore: boolean;
  loadMore: () => void;
  label: "notes" | "files";
}) {
  return (
    <>
      {pending ? <ContentLoading label={`Loading ${label}…`} /> : null}
      {error ? <FieldError>{error.message}</FieldError> : null}
      {hasMore ? (
        <Button variant="outline" size="sm" disabled={fetching} onClick={loadMore}>
          {fetching ? `Loading ${label}…` : `Load more ${label}`}
        </Button>
      ) : null}
    </>
  );
}
